export var OnlineStatusActivityEnum = /*#__PURE__*/ function(OnlineStatusActivityEnum) {
    OnlineStatusActivityEnum["PlayingCitiesAndKnights4P"] = "Playing Cities & Knights 4P";
    OnlineStatusActivityEnum["PlayingCitiesAndKnights56P"] = "Playing Cities & Knights 5-6P";
    OnlineStatusActivityEnum["PlayingCitiesAndKnightsSeafarers4P"] = "Playing SF + C&K 4P";
    OnlineStatusActivityEnum["PlayingCitiesAndKnightsSeafarers56P"] = "Playing SF + C&K 5-6P";
    OnlineStatusActivityEnum["PlayingClassic4P"] = "Playing Base Game 4P";
    OnlineStatusActivityEnum["PlayingClassic5678P"] = "Playing Base Game 5-6P";
    OnlineStatusActivityEnum["PlayingSeafarers4P"] = "Playing Seafarers 4P";
    OnlineStatusActivityEnum["PlayingSeafarers56P"] = "Playing Seafarers 5-6P";
    OnlineStatusActivityEnum["InPrivateRoom"] = "In Private Room";
    OnlineStatusActivityEnum["InPublicRoom"] = "In Public Room";
    OnlineStatusActivityEnum["IsOnlineAndIdle"] = "Idle";
    return OnlineStatusActivityEnum;
}({});
export function getOnlineStatusActivityText(activity) {
    if (activity == undefined) return {
        key: 'strings:colonistCommon.utils.emptyString'
    };
    switch(activity){
        case "Playing Cities & Knights 4P":
            return {
                key: 'strings:profilePage.statusActivity.playingCitiesAndKnights4P'
            };
        case "Playing Cities & Knights 5-6P":
            return {
                key: 'strings:profilePage.statusActivity.playingCitiesAndKnights56P'
            };
        case "Playing SF + C&K 4P":
            return {
                key: 'strings:profilePage.statusActivity.playingCitiesAndKnightsSeafarers4P'
            };
        case "Playing SF + C&K 5-6P":
            return {
                key: 'strings:profilePage.statusActivity.playingCitiesAndKnightsSeafarers56P'
            };
        case "Playing Base Game 4P":
            return {
                key: 'strings:profilePage.statusActivity.playingClassic4P'
            };
        case "Playing Base Game 5-6P":
            return {
                key: 'strings:profilePage.statusActivity.playingClassic5678P'
            };
        case "Playing Seafarers 4P":
            return {
                key: 'strings:profilePage.statusActivity.playingSeafarers4P'
            };
        case "Playing Seafarers 5-6P":
            return {
                key: 'strings:profilePage.statusActivity.playingSeafarers56P'
            };
        case "In Private Room":
            return {
                key: 'strings:profilePage.statusActivity.inPrivateRoom'
            };
        case "In Public Room":
            return {
                key: 'strings:profilePage.statusActivity.inPublicRoom'
            };
        case "Idle":
            return {
                key: 'strings:profilePage.statusActivity.isOnlineAndIdle'
            };
    }
}
